import { string, object, number, date, array } from "yup";

import addressSchema, { createAddressSchema } from "../../utils/common-schemas/Address-schema";

const email = string()
  .email()
  .required("L'email est obligatoire");

const parentSchema = object().shape({
  nom: string().required("Le nom est obligatoire"),
  prenom: string().required("Le prenom est obligatoire"),
  email: email,
  adresseDto: addressSchema,
  dataNaissance: date(),
  sexe: string(),
  situation: string(),
  numeroTel: number()
});

const tierSchema = object().shape({
  nom: string(),
  prenom: string(),
  numeroTel: number(),
  lienDeParente: string()
});

const kidSchema = object().shape({
  photo: string().required(),
  nom: string().required("Le nom est obligatoire"),
  prenom: string().required("Le prénom est obligatoire"),
  dateNaissance: date().required("La date de naissance est obligatoire"),
  dateAdmission: date().required("La date d'admission est obligatoire"),
  adresseDto: addressSchema,
  poid: number(),
  taille: number(),
  parents: array().of(parentSchema),
  tierceAutorisesDto: array().of(tierSchema)
});

export const createKidSchema = (t) => {
  const i18nEmail = string()
    .email()
    .required(t("validation.email_required"));

  const i18nParentSchema = object().shape({
    nom: string().required(t("validation.nom_required")),
    prenom: string().required(t("validation.prenom_required")),
    email: i18nEmail,
    adresseDto: createAddressSchema(t),
    dataNaissance: date(),
    sexe: string(),
    situation: string(),
    numeroTel: number()
  });

  const i18nTierSchema = object().shape({
    nom: string(),
    prenom: string(),
    numeroTel: number(),
    lienDeParente: string()
  });

  return object().shape({
    photo: string().required(),
    nom: string().required(t("validation.nom_required")),
    prenom: string().required(t("validation.prenom_required")),
    dateNaissance: date().required(t("validation.date_naissance_required")),
    dateAdmission: date().required(t("validation.date_admission_required")),
    adresseDto: createAddressSchema(t),
    poid: number(),
    taille: number(),
    parents: array().of(i18nParentSchema),
    tierceAutorisesDto: array().of(i18nTierSchema)
  });
};

export default kidSchema;
